// Environment classification for a company (prod / dev / demo).
//
// This is a PURELY VISUAL label — it does not change any app behaviour,
// API endpoint, or data source. It only drives the badge shown in the
// company list and the select in the edit-company dialog.
//
// It is a NEW, opt-in field: the default is empty (unset). A company with
// no `environment` shows no badge until an admin explicitly assigns one.

export const DEFAULT_ENVIRONMENT = ''

const COMPANY_ENVIRONMENTS = [
  { value: 'prod', label: 'Production', color: '#43a047' },     // green
  { value: 'dev', label: 'Development', color: '#1e88e5' },     // blue
  { value: 'demo', label: 'Demo', color: '#8e24aa' },           // purple
]

export function getCompanyEnvironments() {
  return COMPANY_ENVIRONMENTS
}

// Returns the config for a value, or null when unset / unknown so the
// caller can hide the badge instead of inventing a default.
export function getEnvironmentConfig(value) {
  return COMPANY_ENVIRONMENTS.find((e) => e.value === value) || null
}

// Resolves the badge config to render for a company-like object (anything
// holding `environment` and `showEnvironmentBadge`). Returns null — i.e.
// no badge — when there is no env set OR the badge is explicitly hidden.
// `showEnvironmentBadge` defaults to shown, so it must be exactly `false`
// to suppress the badge.
export function getCompanyBadge(source) {
  if (!source) return null
  if (source.showEnvironmentBadge === false) return null
  return getEnvironmentConfig(source.environment)
}
